import React, { useMemo } from "react";
import * as THREE from "three";
import { makeFacade } from "../lib/textures";

// Procedural Woolworth Building — the "Cathedral of Commerce": a slender terracotta
// gothic tower with stepped setbacks and a green copper pyramidal crown + spire.
// (Procedural landmark, not an imported Draco .glb — licensed WTC-area models are not
// available in-environment; a stylised recognisable silhouette reads best here anyway.)
export default function Woolworth() {
  const tex = useMemo(() => makeFacade("stone"), []);
  const terracotta = "#cdbb99";
  const copper = "#6fae9c";
  const Block = ({ y, h, w, d }) => (
    <mesh position={[0, y + h / 2, 0]} castShadow receiveShadow>
      <boxGeometry args={[w, h, d]} />
      <meshStandardMaterial map={tex.map} color={terracotta} roughness={0.9} metalness={0.03} />
    </mesh>
  );
  return (
    <group position={[150, 0, -300]} rotation={[0, Math.PI * 0.12, 0]}>
      {/* stepped shaft with gothic setbacks */}
      <Block y={0} h={120} w={46} d={46} />
      <Block y={120} h={70} w={34} d={34} />
      <Block y={190} h={48} w={24} d={24} />
      {/* corner buttress turrets on the main setback */}
      {[[-15, -15], [15, -15], [-15, 15], [15, 15]].map(([x, z], i) => (
        <mesh key={i} position={[x, 128, z]} castShadow>
          <cylinderGeometry args={[2.4, 2.4, 24, 6]} />
          <meshStandardMaterial map={tex.map} color={terracotta} roughness={0.9} />
        </mesh>
      ))}
      {/* copper crown */}
      <mesh position={[0, 238 + 9, 0]} castShadow>
        <boxGeometry args={[18, 18, 18]} />
        <meshStandardMaterial color={copper} roughness={0.55} metalness={0.35} />
      </mesh>
      <mesh position={[0, 265, 0]} castShadow>
        <coneGeometry args={[13, 34, 4]} />
        <meshStandardMaterial color={copper} roughness={0.5} metalness={0.35} />
      </mesh>
      {/* finial spire */}
      <mesh position={[0, 292, 0]}>
        <cylinderGeometry args={[0.5, 0.5, 14, 6]} />
        <meshStandardMaterial color="#d9d2c0" metalness={0.4} roughness={0.4} />
      </mesh>
      {/* small corner spirelets on the crown */}
      {[[-8, -8], [8, -8], [-8, 8], [8, 8]].map(([x, z], i) => (
        <mesh key={`s${i}`} position={[x, 250, z]}>
          <coneGeometry args={[2.2, 12, 4]} />
          <meshStandardMaterial color={copper} roughness={0.5} metalness={0.3} />
        </mesh>
      ))}
    </group>
  );
}
